// CurrencyContext.js
import React, { createContext, useContext, useMemo } from 'react';
import { useCompany } from './CompanyContext';
import { getCurrencySymbol } from '../utils/currency';

const CurrencyContext = createContext();

export function useCurrency() {
  return useContext(CurrencyContext);
}

// Never changes and takes no arguments, so a single module-level reference
// keeps it stable across every render/provider instance - no need for
// useCallback just to re-create the same no-op.
const noop = () => {};

// Derives the currency symbol from the server-backed Company document
// rather than reading from localStorage or a duplicated profile copy.
export function CurrencyProvider({ children }) {
  const { company } = useCompany();
  const currency = getCurrencySymbol(company?.currency);

  const value = useMemo(() => ({ currency, updateCurrency: noop }), [currency]);

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  );
}

export default CurrencyContext;
